import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import gardinerhouse from '../assets/gardinerhouse.jpg';
import stmarys from '../assets/stmarys.jpg';
import castlehillinn from '../assets/castlehillinn.png';

import addToCalendar from '../assets/addToCalendar.png'

import NavMenu from './NavMenu';
import * as utils from './Utils.js'

const Schedule = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="Schedule">
      <Helmet>
        <title>Schedule</title>
        <meta
          name="description"
          content="View the full wedding weekend schedule, ceremony time, and reception details for Chandler and Anna's wedding."
        />

        <meta property="og:title" content="Schedule | Chandler & Anna" />
        <meta
          property="og:description"
          content="View the full wedding weekend schedule, ceremony time, and reception details for Chandler and Anna's wedding."
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/schedule.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/schedule" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Schedule</p>
          <a class="btn btn-outline-navyblue" href="/calendars/wedding-weekend.ics" download="wedding-weekend.ics">
            Add all events to calendar
          </a>
        </div>

        <div className='wedding-centerpiece'>
          <div className='schedule'>
            <div className='schedule-day'>
              <p className='schedule-date-title'>Friday, April 24th</p>
              <div className='schedule-day-events'>
                <div className='schedule-event'>
                  <a class="btn btn-navyblue desktop-only" href="/calendars/welcome-party.ics" download="welcome-party.ics">
                    Add to calendar
                  </a>

                  <div className='schedule-event-container'>
                    <div className='schedule-event-title-and-time'>
                      <p className='schedule-event-title'>Welcome Party</p>
                      <p className='schedule-event-time'>8:00pm - 10:00pm</p>
                      <p className='pretty-asterisk green desktop-only'>*</p>
                      <p className='schedule-event-details'>Welcome to Newport, Rhode Island! Please join us for an evening of drinks and appetizers.</p>
                      <p className='schedule-event-details'><strong>Dress Code:</strong> Dressy Casual</p>
                    </div>

                    <a type="button" className="mobile-only add-to-calendar-btn-sm" href="/calendars/welcome-party.ics" download="welcome-party.ics">
                      <img src={addToCalendar} alt="Add to calendar" className="add-to-calendar-icon" />
                    </a>

                    <div className='schedule-event-location-details'>
                      <img src={gardinerhouse} className='location-image gardiner-house'/>
                      <p className='schedule-event-location'>Gardiner House</p>
                      <div className='schedule-list-item-links'>
                        <a href="https://maps.apple.com/place?address=24%20Lee's%20Whf,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.481469,-71.315530&name=Gardiner%20House&place-id=I8D26980B2898431C&map=explore" target="_blank" rel="noopener noreferrer"> Map</a>
                        |
                        <a href="https://maps.app.goo.gl/euLiiH8ScyTnWaeR6" target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='schedule-day'>
              <p className='schedule-date-title'>Saturday, April 25th</p>
              
              <div className="alert alert-primary-wedding" role="alert" style={{ marginBottom: '16px' }}>
                Visit the <Link to="/transportation" className="link-to-page" style={{ fontWeight: 700 }}>Transportation</Link> page to find your assigned shuttle pick-up location to take you to the ceremony.
              </div>

              <div className='schedule-day-events'>
                <div className='schedule-event'>
                  <a class="btn btn-navyblue desktop-only" href="/calendars/ceremony.ics" download="ceremony.ics">
                    Add to calendar
                  </a>

                  <div className='schedule-event-container'>
                    <div className='schedule-event-title-and-time'>
                      <p className='schedule-event-title'>Wedding Ceremony</p>
                      <p className='schedule-event-time'>2:00pm - 3:00pm</p>
                      <p className='schedule-event-time green'>Please arrive no later than 1:40pm!</p>
                      <p className='pretty-asterisk green desktop-only'>*</p>
                      <p className='schedule-event-details'>Come witness our wedding vows at the beautiful and historic <span className='nowrap'>St. Mary's Church</span>, the first Roman Catholic Parish in <span className='nowrap'>Rhode Island</span>, established in 1828.</p>
                      <p className='schedule-event-details'><strong>Dress Code:</strong> Black Tie</p>
                    </div>

                    <a type="button" className="mobile-only add-to-calendar-btn-sm" href="/calendars/ceremony.ics" download="ceremony.ics">
                      <img src={addToCalendar} alt="Add to calendar" className="add-to-calendar-icon" />
                    </a>

                    <div className='schedule-event-location-details'>
                      <img src={stmarys} className='location-image stmarys'/>
                      <p className='schedule-event-location'>St. Mary's Roman Catholic Church</p>
                      <div className='schedule-list-item-links'>
                        <a href="https://maps.apple.com/place?address=12%20William%20St,%20Newport,%20RI%20%2002840,%20United%20States&coordinate=41.484036,-71.312688&name=Saint%20Mary,%20Our%20Lady%20of%20the%20Isle%20Roman%20Catholic%20Church%20Newport,%20Rhode%20Island&place-id=IBB7A8E706163C5EE&map=explore" target="_blank" rel="noopener noreferrer"> Map</a>
                        |
                        <a href="https://maps.app.goo.gl/yxZ3sfyEsW5LvDoY7" target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="alert alert-primary-wedding" role="alert" style={{ marginBottom: '16px' }}>
                  Shuttles will take guests from St. Mary's to Castle Hill Inn after the ceremony. Beverages will be provided on the shuttle.
                </div>

                <div className='schedule-event'>
                  <a class="btn btn-navyblue desktop-only" href="/calendars/cocktail-hour-and-reception.ics" download="cocktail-hour-and-reception.ics">
                    Add to calendar
                  </a>

                  <div className='schedule-event-container'>
                    <div className='schedule-event-title-and-time'>
                      <p className='schedule-event-title'>Cocktail Hour + Reception</p>
                      <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-around'}}>
                        <div>
                          <p className='schedule-event-subtitle'>Cocktail Hour</p>
                          <p className='schedule-event-time'>4:00pm - 5:30pm</p>
                        </div>
                        <div>
                          <p className='schedule-event-subtitle'>Reception</p>
                          <p className='schedule-event-time'>5:30pm - 10:00pm</p>
                        </div>
                      </div>
                      
                      <p className='pretty-asterisk green desktop-only'>*</p>
                      <p className='schedule-event-details'>Let's get the party started! Drinks and heavy appetizers overlooking Newport Harbor, followed by dinner and dancing (and maybe a few more drinks)!</p>
                      <p className='schedule-event-details'><strong>Dress Code:</strong> Black Tie</p>
                    </div>

                    <a type="button" className="mobile-only add-to-calendar-btn-sm" href="/calendars/cocktail-hour-and-reception.ics" download="cocktail-hour-and-reception.ics">
                      <img src={addToCalendar} alt="Add to calendar" className="add-to-calendar-icon" />
                    </a>

                    <div className='schedule-event-location-details'>
                      <img src={castlehillinn} className='location-image castle-hill-inn'/>
                      <p className='schedule-event-location'>Castle Hill Inn</p>
                      <div className='schedule-list-item-links'>
                        <a href="https://maps.apple.com/place?address=590%20Ocean%20Drive,%20Newport,%20RI%2002840,%20United%20States&coordinate=41.464017,-71.360777&name=Castle%20Hill%20Inn&place-id=I412FB56F12D2BF6C&map=explore" target="_blank" rel="noopener noreferrer"> Map</a>
                        |
                        <a href="https://maps.app.goo.gl/37JsLMKoMPw8PAi7A" target="_blank" rel="noopener noreferrer"><span style={{ fontWeight: '700' }}>G</span> Map</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='wedding-centerpiece' style={{display: 'none'}}>
          <p style={{ fontFamily: 'nyt-franklin', fontWeight: 300 }}>Testing This Font - nyt-franklin 300</p>
          <p style={{ fontFamily: 'nyt-franklin', fontWeight: 500 }}>Testing This Font - nyt-franklin 500</p>
          <p style={{ fontFamily: 'nyt-franklin', fontWeight: 700 }}>Testing This Font - nyt-franklin 700</p>
          <p style={{ fontFamily: 'nyt-imperial', fontWeight: 400 }}>Testing This Font - nyt-imperial 400</p>
          <p style={{ fontFamily: 'nyt-imperial', fontWeight: 700 }}>Testing This Font - nyt-imperial 700</p>
          <p style={{ fontFamily: 'nyt-karnak', fontWeight: 900 }}>Testing This Font - nyt-karnak 900</p>
          <p style={{ fontFamily: 'nyt-cheltenham', fontWeight: 200 }}>Testing This Font - nyt-cheltenham 200</p>
          <p style={{ fontFamily: 'nyt-cheltenham', fontWeight: 300 }}>Testing This Font - nyt-cheltenham 300</p>
          <p style={{ fontFamily: 'nyt-cheltenham', fontWeight: 400 }}>Testing This Font - nyt-cheltenham 400</p>
          <p style={{ fontFamily: 'nyt-cheltenham', fontWeight: 500 }}>Testing This Font - nyt-cheltenham 500</p>
          <p style={{ fontFamily: 'nyt-cheltenham', fontWeight: 700 }}>Testing This Font - nyt-cheltenham 700</p>
          <p style={{ fontFamily: 'nyt-cheltenham-small', fontWeight: 400 }}>Testing This Font - nyt-cheltenham-small 400</p>
          <p style={{ fontFamily: 'nyt-cheltenham-small', fontWeight: 400, fontStyle: 'italic' }}>Testing This Font - nyt-cheltenham-small 400 italic</p>
          <p style={{ fontFamily: 'nyt-cheltenham-small', fontWeight: 700 }}>Testing This Font - nyt-cheltenham-small 700</p>
          <p style={{ fontFamily: 'nyt-cheltenham-cond', fontWeight: 300 }}>Testing This Font - nyt-cheltenham-cond 300</p>
          <p style={{ fontFamily: 'nyt-cheltenham-cond', fontWeight: 700 }}>Testing This Font - nyt-cheltenham-cond 700</p>
          <p style={{ fontFamily: 'stregis-caslon', fontWeight: 400 }}>Testing This Font - stregis-caslon 400</p>
          <p style={{ fontFamily: 'stregis-caslon', fontWeight: 400, fontStyle: 'italic' }}>Testing This Font - stregis-caslon 400 italic</p>

        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['green', 'ivory']) }
      </div>
    </div>
  );
}

export default Schedule;
